export default "__VITE_ASSET__CLhuVqpN__"